import React from "react";
import {
    Navigate,
} from "react-router-dom";


const CashRegisterListComponent = React.lazy(() => import("../../../../../components/cash-register/components/list/page"));
const CashRegisterAddComponent = React.lazy(() => import("../../../../../components/cash-register/components/open/page"));
const CashRegisterMovementsComponent = React.lazy(() => import("../../../../../components/cash-register/components/movements/page"));
export const cashRegisterRoutes = [
   
    {
        path: 'add',
        element: <CashRegisterAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/finanzas/cash-register/add" />
    },
    {
        path:'movements',
        element:<CashRegisterMovementsComponent/>
    },
    {
        path: 'edit/:id',
        element: <CashRegisterAddComponent />
    },
     {
        path: 'list',
        element: <CashRegisterListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/finanzas/cash-register/list" />
    },
];

